import { createSonarSelector } from '@lib/selectors';
import { useMemo } from 'react';
import { useOptimisticUpdate } from '../useOptimisticUpdate';
import { useSonarSelector } from '../useSonarSelector';
const mapSelector = createSonarSelector((state) => state.core.sonarObjects.byIdMap);
const emptyMap = {};
const empty = {
    context: {
        definition: '',
        notes: ''
    },
    ingestedBy: [],
    initiativeIds: [],
    linkedIntegrations: [],
    populatedBy: [],
    relatedCounts: {},
    salesforce: {},
    stakeholders: [],
    tagIds: [],
    users: []
};
/**
 * Subscribes to the shared state for a particular sonar object.
 * @param sonarObjectId The id of the sonar object to subscribe to.
 * @returns A {@link SonarObjectReference} instance for the provided id.
 */
export function useSonarObjectReference(sonarObjectId) {
    const { changes } = useOptimisticUpdate(sonarObjectId);
    const reference = useSonarSelector((state) => { var _a, _b; return (_b = ((_a = mapSelector(state).data) !== null && _a !== void 0 ? _a : emptyMap)[sonarObjectId]) !== null && _b !== void 0 ? _b : empty; });
    const result = useMemo(() => (Object.assign(Object.assign({}, reference), { salesforce: Object.assign(Object.assign({}, reference.salesforce), changes) })), [changes, reference]);
    return result;
}
